import styled from 'styled-components';
import neutral from '../../themes/neutral/index.js';

var ContentWrapper = styled.div.withConfig({
  displayName: "Alertstyles__ContentWrapper",
  componentId: "sc-u60gra-0"
})(["display:flex;align-items:center;flex-direction:column;min-height:34px;@media (min-width:", "){flex-direction:row;}"], neutral.breakpoints.mobile);
var IconContainer = styled.div.withConfig({
  displayName: "Alertstyles__IconContainer",
  componentId: "sc-u60gra-1"
})(["display:flex;"]);
var MessageContainer = styled.div.withConfig({
  displayName: "Alertstyles__MessageContainer",
  componentId: "sc-u60gra-2"
})(["display:flex;align-items:center;width:100%;"]);
var Message = styled.div.withConfig({
  displayName: "Alertstyles__Message",
  componentId: "sc-u60gra-3"
})(["margin:0 ", ";"], neutral.spacings.small);
var ActionContainer = styled.div.withConfig({
  displayName: "Alertstyles__ActionContainer",
  componentId: "sc-u60gra-4"
})(["margin-top:", ";width:100%;@media (min-width:", "){margin-top:0;width:auto;}"], neutral.spacings.small, neutral.breakpoints.mobile);
var StyledAlert = styled.div.withConfig({
  displayName: "Alertstyles__StyledAlert",
  componentId: "sc-u60gra-5"
})(["position:relative;font-family:", ";padding:", " ", ";font-size:", ";line-height:", ";border-radius:2px;&.alert-with-close{padding-right:calc(", " + 2rem);.alert-close{position:absolute;right:", ";margin-right:-6px;top:9px;}}&.sok-alert{.sok-btn.sok-btn-text:not([disabled]):hover{color:unset;}}&.alert-banner{border-radius:initial;}&.alert-type-error{background-color:", ";color:", ";}&.alert-type-warning{background-color:", ";color:", ";}&.alert-type-info{background-color:", ";color:", ";}&.alert-type-success{background-color:", ";color:", ";}&.alert-mobile{", "{flex-direction:column;}", "{margin-top:", ";width:100%;}}"], function (props) {
  return props.theme.alert.fontFamily;
}, neutral.spacings.xxSmall, neutral.spacings.medium, function (props) {
  return props.theme.alert.fontSize;
}, function (props) {
  return props.theme.alert.lineHeight;
}, neutral.spacings.medium, neutral.spacings.medium, neutral.colors.error50, neutral.colors.error900, neutral.colors.warning50, neutral.colors.warning900, neutral.colors.info50, neutral.colors.info900, neutral.colors.success50, neutral.colors.success900, ContentWrapper, ActionContainer, neutral.spacings.small);

export { ActionContainer, ContentWrapper, IconContainer, Message, MessageContainer, StyledAlert };
//# sourceMappingURL=Alert.styles.js.map
